<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @closed="closed"
             width="600px">
    <div style="margin: 20px 110px 0 80px">
      <el-form label-position="right" label-width="90px" :model="warehouse" :rules="rules" ref="warehouse">
        <input-form-item label="仓库编号" prop="code"></input-form-item>
        <input-form-item label="仓库名称" prop="name"></input-form-item>
        <remote-form-item label="仓库类型" class-name="WAREHOUSE_TYPE" prop="typeCode" using-code></remote-form-item>
        <textarea-form-item label="备注" prop="remarks"></textarea-form-item>
      </el-form>
    </div>

    <template #footer>
      <el-button v-if="isNew" type="primary" @click="add()">新 增</el-button>
      <el-button v-else-if="!readOnly" type="primary" @click="save()">保 存</el-button>
      <el-button @click="cancel">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>

import InputFormItem from '@/components/form/InputFormItem'
import TextareaFormItem from '@/components/form/TextareaFormItem'
import RemoteFormItem from '@/components/form/RemoteFormItem'

export default {
  name: 'EditWarehouseDialog',
  components: {
    RemoteFormItem,
    TextareaFormItem,
    InputFormItem
  },
  props: {
    warehouse: {
      type: Object,
      required: true
    },
    readOnly: Boolean
  },
  data () {
    return {
      rules: {
        name: [
          {
            required: true,
            message: '请输入仓库名称',
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入仓库编号',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    closed () {
      if (!this.readOnly) {
        this.$refs.warehouse.resetFields()
      }
    },
    add () {
      this.$refs.warehouse.validate(valid => {
        if (!valid) return

        this.$store.dispatch('warehouse/add', this.$_.cloneDeep(this.warehouse)).then(() => {
          this.hide()
          this.$message.success('添加成功!')
        })
      })
    },
    save () {
      this.$refs.warehouse.validate(valid => {
        if (!valid) return

        this.$store.dispatch('warehouse/updateOne', this.$_.cloneDeep(this.warehouse)).then(() => {
          this.hide()
        })
      })
    },
    cancel () {
      this.hide()
    },
    hide () {
      this.$emit('update:visible', false)
    }
  },
  computed: {
    isNew () {
      return !this.warehouse.id
    },
    controlReadOnly () {
      return !this.isNew && this.readOnly
    },
    title () {
      if (this.isNew) return '新增仓库'
      return this.readOnly ? '仓库详细信息' : '编辑仓库'
    }
  }
}
</script>
